import React from 'react';

const caseStudies = [
  {
    num: '01',
    industry: 'Real Estate · California',
    company: 'Cari & Britt',
    service: 'Appointment Setting & Sales Closing',
    overview: 'Reflex Advisor led a comprehensive 12-month acquisition campaign for this reputable California-based real estate firm. The objective was to identify and connect with homeowners interested in direct cash offers, managing the full outreach lifecycle from initial contact through to appointment.',
    deliverables: [
      'Executed a high-volume outreach strategy targeting qualified homeowners across California.',
      'Managed the full contact, qualification, and appointment setting process on behalf of the client.',
      'Facilitated informed decision-making for sellers, directly contributing to the firm\'s acquisition pipeline over a sustained 12-month engagement.',
    ],
    img: 'https://files.manuscdn.com/user_upload_by_module/session_file/310519663711222792/YGtaFziEWuQAyTzE.jpg',
    page: '01 / 10',
  },
  {
    num: '02',
    industry: 'EdTech · Switzerland',
    company: 'Moneytree Consulting',
    service: 'Appointment Setting & Sales Closing',
    overview: 'Moneytree Consulting is a premium Swiss organization in the video production education space, widely regarded as one of the top providers in its niche. Reflex Advisor was engaged to manage their high-ticket closing operations, ensuring every prospect interaction reflected the brand\'s prestige.',
    deliverables: [
      'Took full ownership of the closing operation for their high-ticket video editing courses.',
      'Built consultative, trust-based relationships with prospective students to align course value with individual career goals.',
      'Maintained the brand\'s prestigious reputation through high-touch, professional sales interactions that consistently met quality standards.',
    ],
    img: 'https://files.manuscdn.com/user_upload_by_module/session_file/310519663711222792/AycwqhRKoeJkNWot.jpg',
    page: '02 / 10',
  },
  {
    num: '03',
    industry: 'Telesales & Digital Marketing',
    company: 'GrokPro',
    service: 'Strategic Telesales Implementation',
    overview: 'Reflex Advisor partnered with GrokPro to enhance their telesales and customer support frameworks. Working across a diverse range of industries, we helped tailor outreach strategies to meet the unique market demands of GrokPro\'s varied client base.',
    deliverables: [
      'Deployed specialized teams with expertise in telesales and digital marketing alignment across multiple verticals.',
      'Tailored outreach strategies to fit the specific market dynamics of GrokPro\'s diverse client portfolio.',
      'Drove measurable improvements in both customer acquisition rates and long-term retention metrics.',
    ],
    img: 'https://files.manuscdn.com/user_upload_by_module/session_file/310519663711222792/SSFPTbPWQkzVTLss.jpg',
    page: '03 / 10',
  },
  {
    num: '04',
    industry: 'FinTech · Payment Processing · Lithuania',
    company: 'Kwikwire',
    service: 'B2B Appointment Setting & Sales Closing',
    overview: 'Kwikwire is a highly regulated Lithuanian PSP (Payment Service Provider) backed by Arkanium Technologies, serving the forex trading and gambling sectors. Reflex Advisor was tasked with specialized B2B outreach in a complex, high-compliance environment.',
    deliverables: [
      'Developed a thorough understanding of complex, high-risk payment processing technologies to communicate value accurately to technical buyers.',
      'Executed targeted B2B outreach, establishing direct connections with over 200 brokers and gambling operators.',
      'Represented the client at major industry expos and events, driving brand visibility and fostering strategic partnerships within the sector.',
    ],
    img: 'https://files.manuscdn.com/user_upload_by_module/session_file/310519663711222792/pzkTOkMcqhxaPiNO.jpg',
    page: '04 / 10',
  },
  {
    num: '05',
    industry: 'B2B SaaS',
    company: 'Qisst Pay',
    service: 'Appointment Setting, Closing & Team Coaching',
    overview: 'For this fast-growing SaaS platform, Reflex Advisor stepped in to drive B2B sales while simultaneously optimizing the internal sales infrastructure. Over a 12-month engagement, we closed over 100 B2B clients and contributed directly to the team\'s overall performance.',
    deliverables: [
      'Closed deals with over 100 B2B clients, generating significant new revenue contribution for the platform.',
      'Collaborated closely with product and marketing teams to align sales messaging with rapid product development cycles.',
      'Provided direct mentorship and coaching to the internal sales team, elevating performance, skill levels, and conversion rates across the board.',
    ],
    img: 'https://files.manuscdn.com/user_upload_by_module/session_file/310519663711222792/HPAYahUeoRxpnEbp.jpg',
    page: '05 / 10',
  },
  {
    num: '06',
    industry: 'Staffing & HR',
    company: 'HOXLP Recruitment',
    service: 'Appointment Setting & Sales Closing',
    overview: 'Reflex Advisor partnered with HOXLP Recruitment to streamline their client acquisition process, connecting the firm with companies actively seeking staffing and recruitment solutions across an 8-month engagement.',
    deliverables: [
      'Executed targeted appointment setting campaigns aimed at HR directors and hiring managers across relevant industries.',
      'Deployed consultative closing strategies to convert qualified prospects into retained clients.',
      'Ensured mutually beneficial agreements through effective negotiation and clear communication of the firm\'s unique value proposition.',
    ],
    img: 'https://files.manuscdn.com/user_upload_by_module/session_file/310519663711222792/aoYoYvPSeiruYNYv.jpg',
    page: '06 / 10',
  },
  {
    num: '07',
    industry: 'Cybersecurity',
    company: 'BruteFix',
    service: 'B2B Appointment Setting & Sales Closing',
    overview: 'BruteFix is a cybersecurity firm renowned for cutting-edge penetration testing and vulnerability assessment services. Selling complex, high-stakes technical services requires a partner capable of translating deep technical capability into clear business value — which is exactly what Reflex Advisor delivered.',
    deliverables: [
      'Engaged directly with IT directors and CISOs, aligning BruteFix\'s technical capabilities with each prospect\'s unique security vulnerabilities and risk profile.',
      'Successfully translated complex cybersecurity concepts into clear, compelling business value propositions for non-technical decision-makers.',
      'Forged meaningful, long-term client relationships that expanded BruteFix\'s enterprise client base significantly.',
    ],
    img: 'https://files.manuscdn.com/user_upload_by_module/session_file/310519663711222792/DIfNsVSSvkwkfJsU.jpg',
    page: '07 / 10',
  },
  {
    num: '08',
    industry: 'Insurance & Financial Services',
    company: 'Wentworth-DeAngelis & Kaufman',
    service: 'Appointment Setting & Sales Closing',
    overview: 'This full-service insurance brokerage and consulting firm specializes in employee benefits and property casualty insurance. They required a professional, consultative outreach approach capable of building trust with organizational leaders in a sensitive, high-consideration category.',
    deliverables: [
      'Conducted highly targeted outreach to organizational leaders, uncovering unique risk and benefits concerns before any sales conversation began.',
      'Articulated the specific value of complex insurance solutions in terms directly relevant to each prospect\'s corporate structure and needs.',
      'Built a strong, qualified pipeline of prospects ready for consultative review, reducing time-to-close for the firm\'s internal advisors.',
    ],
    img: 'https://files.manuscdn.com/user_upload_by_module/session_file/310519663711222792/rwIQmbaWpBRqhszC.jpg',
    page: '08 / 10',
  },
  {
    num: '09',
    industry: 'Automotive Fleet · California',
    company: 'Oxo Car Rental',
    service: 'Appointment Setting & Sales Closing',
    overview: 'For this California-based automotive rental agency, Reflex Advisor managed the complete customer interaction lifecycle — from initial inquiry through to final booking — driving both foot traffic and revenue for the agency.',
    deliverables: [
      'Managed inbound inquiries and outbound follow-ups to drive qualified foot traffic to the rental agency\'s locations.',
      'Handled the closing process, presenting vehicle options and upselling premium services based on customer needs and preferences.',
      'Addressed customer concerns and ensured a seamless, high-satisfaction booking experience that supported repeat business.',
    ],
    img: 'https://files.manuscdn.com/user_upload_by_module/session_file/310519663711222792/YPXphqOFoZBlvWEv.jpg',
    page: '09 / 10',
  },
  {
    num: '10',
    industry: 'EdTech & Mentorship',
    company: 'Gleac',
    service: 'Appointment Setting & Sales Closing',
    overview: 'Gleac offers a revolutionary micro-learning and mentorship platform, allowing users to engage in practical skill development through real-world digital experiences. Reflex Advisor was tasked with connecting ambitious professionals with this transformative platform at scale.',
    deliverables: [
      'Executed consultative sales conversations to understand the specific career development goals of each potential user before presenting the platform.',
      'Communicated the unique value proposition of Gleac\'s real-world, practical micro-learning system in terms directly relevant to each prospect\'s ambitions.',
      'Drove consistent user acquisition by aligning the platform\'s core capabilities with the immediate, tangible needs of the target market.',
    ],
    img: 'https://files.manuscdn.com/user_upload_by_module/session_file/310519663711222792/oDziDFGMSRSSxWZb.jpg',
    page: '10 / 10',
  },
];

export default function SoftwareCaseStudy() {
  return (
    <div className="scs-root">

      {/* ── COVER ── */}
      <div className="scs-cover">
        <div className="scs-cover-top">
          <div>
            <div className="scs-cover-brand">REFLEX ADVISOR</div>
            <div className="scs-cover-tag">B2B Client Acquisition</div>
          </div>
          <div className="scs-cover-year">2026</div>
        </div>
        <div className="scs-cover-mid">
          <div className="scs-cover-label">Company Portfolio</div>
          <h1 className="scs-cover-h1">Client<br />Acquisition<br />Track Record.</h1>
          <p className="scs-cover-sub">A selection of industries and companies where Reflex Advisor has driven measurable acquisition outcomes — from appointment setting to full-cycle sales closing.</p>
        </div>
        <div>
          <div className="scs-cover-divider" />
          <div className="scs-cover-stats">
            <div>
              <div className="scs-stat-num">10+</div>
              <div className="scs-stat-label">Industries Served</div>
            </div>
            <div>
              <div className="scs-stat-num">100+</div>
              <div className="scs-stat-label">B2B Clients Closed</div>
            </div>
            <div>
              <div className="scs-stat-num">200+</div>
              <div className="scs-stat-label">Broker Relationships Built</div>
            </div>
          </div>
        </div>
      </div>

      {/* ── INTRO ── */}
      <div className="scs-intro">
        <div className="scs-intro-eyebrow">About This Portfolio</div>
        <h2 className="scs-intro-h2">We Step In.<br />You Scale Up.</h2>
        <p className="scs-intro-p">At Reflex Advisor, we build high-performing acquisition systems for businesses across diverse industries. From B2B SaaS to high-ticket consulting and specialized services, our team of experienced BDRs and SDRs manages the entire top-of-funnel process — allowing founders and core teams to focus on fulfillment and growth.</p>
        <p className="scs-intro-p">The following pages document a selection of our past work, demonstrating our ability to adapt to complex markets, execute targeted outreach, and close deals across verticals.</p>
        <div className="scs-intro-rule" />
        <div className="scs-intro-grid">
          <div>
            <div className="scs-intro-num">10+</div>
            <div className="scs-intro-item-label">Industries covered<br />across this portfolio</div>
          </div>
          <div>
            <div className="scs-intro-num">100+</div>
            <div className="scs-intro-item-label">B2B clients closed<br />across campaigns</div>
          </div>
          <div>
            <div className="scs-intro-num">200+</div>
            <div className="scs-intro-item-label">Broker &amp; operator<br />relationships established</div>
          </div>
        </div>
      </div>

      {/* ── CASE STUDIES ── */}
      {caseStudies.map((c) => (
        <div className="scs-case" key={c.num}>
          <div className="scs-case-header">
            <div className="scs-case-num">{c.num}</div>
            <div className="scs-case-header-right">
              <div className="scs-case-industry">{c.industry}</div>
              <div className="scs-case-company">{c.company}</div>
              <div className="scs-case-service">{c.service}</div>
            </div>
          </div>
          <div className="scs-case-body">
            <p className="scs-case-overview">{c.overview}</p>
            <div className="scs-case-rule" />
            <div className="scs-case-del-label">What We Delivered</div>
            <ul className="scs-case-list">
              {c.deliverables.map((d, i) => (
                <li key={i}>{d}</li>
              ))}
            </ul>
          </div>
          <div className="scs-proof-wrap">
            <div className="scs-proof-label"><span>Campaign Proof &amp; Work Samples</span></div>
            <img src={c.img} alt={`${c.company} campaign proof`} className="scs-proof-img" />
          </div>
          <div className="scs-case-footer">
            <div className="scs-footer-brand">REFLEX ADVISOR</div>
            <div className="scs-footer-pg">Case Study {c.page}</div>
          </div>
        </div>
      ))}

      {/* ── BACK COVER ── */}
      <div className="scs-back">
        <div className="scs-back-label">Ready to Work Together?</div>
        <h2 className="scs-back-h2">Let's Build Your<br />Acquisition Engine.</h2>
        <p className="scs-back-sub">Whether you are a software company looking for your first 10 clients or an established business ready to scale, Reflex Advisor has the team and the system to make it happen.</p>
        <a href="https://www.reflexadvisor.com/booking" className="scs-back-btn">Schedule a Discovery Call</a>
        <div className="scs-back-contact">
          <p>+1 647 846 0916 &nbsp;&middot;&nbsp; +1 647 846 2411</p>
          <p>info@reflexadvisor.com</p>
          <p>222 Jarvis St, Toronto, ON M5B 2B8, Canada</p>
          <p>reflexadvisor.com</p>
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Archivo+Black&family=Inter:wght@400;500;600&display=swap');

        .scs-root {
          background: #F2F2F2;
          font-family: 'Inter', Helvetica, Arial, sans-serif;
          -webkit-font-smoothing: antialiased;
          color: #1D1D1F;
        }
        .scs-root *, .scs-root *::before, .scs-root *::after {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        /* COVER */
        .scs-cover {
          background: #0A0A0A;
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 64px 72px;
        }
        .scs-cover-top {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
        }
        .scs-cover-brand {
          font-family: 'Archivo Black', 'Arial Black', Arial, sans-serif;
          font-size: 18px;
          color: #FFFFFF;
          letter-spacing: -0.01em;
        }
        .scs-cover-tag {
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #DA7756;
          margin-top: 6px;
        }
        .scs-cover-year {
          font-size: 12px;
          color: rgba(255,255,255,0.35);
        }
        .scs-cover-mid {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 80px 0 60px;
        }
        .scs-cover-label {
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          color: #DA7756;
          margin-bottom: 24px;
        }
        .scs-cover-h1 {
          font-family: 'Archivo Black', 'Arial Black', Arial, sans-serif;
          font-size: 64px;
          line-height: 1.0;
          letter-spacing: -0.03em;
          color: #FFFFFF;
          margin-bottom: 28px;
        }
        .scs-cover-sub {
          font-size: 17px;
          font-weight: 400;
          color: rgba(255,255,255,0.45);
          line-height: 1.65;
          max-width: 520px;
        }
        .scs-cover-divider {
          height: 1px;
          background: rgba(255,255,255,0.08);
          margin: 0 0 32px;
        }
        .scs-cover-stats {
          display: flex;
          gap: 56px;
        }
        .scs-stat-num {
          font-family: 'Archivo Black', 'Arial Black', Arial, sans-serif;
          font-size: 32px;
          color: #DA7756;
          letter-spacing: -0.02em;
        }
        .scs-stat-label {
          font-size: 12px;
          color: rgba(255,255,255,0.38);
          margin-top: 4px;
        }

        /* INTRO */
        .scs-intro {
          background: #FFFFFF;
          padding: 80px 72px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        .scs-intro-eyebrow {
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #DA7756;
          margin-bottom: 20px;
        }
        .scs-intro-h2 {
          font-family: 'Archivo Black', 'Arial Black', Arial, sans-serif;
          font-size: 42px;
          line-height: 1.08;
          letter-spacing: -0.025em;
          color: #1D1D1F;
          margin-bottom: 24px;
        }
        .scs-intro-p {
          font-size: 16px;
          color: #6E6E73;
          line-height: 1.75;
          margin-bottom: 16px;
          max-width: 600px;
        }
        .scs-intro-rule {
          height: 1px;
          background: #EBEBEB;
          margin: 40px 0;
        }
        .scs-intro-grid {
          display: flex;
          gap: 48px;
        }
        .scs-intro-num {
          font-family: 'Archivo Black', 'Arial Black', Arial, sans-serif;
          font-size: 30px;
          color: #DA7756;
          letter-spacing: -0.02em;
        }
        .scs-intro-item-label {
          font-size: 13px;
          color: #6E6E73;
          margin-top: 6px;
          line-height: 1.5;
        }

        /* CASE STUDY */
        .scs-case {
          background: #FFFFFF;
          border-top: 8px solid #F2F2F2;
        }
        .scs-case-header {
          background: #0A0A0A;
          padding: 44px 72px 40px;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
        }
        .scs-case-num {
          font-family: 'Archivo Black', 'Arial Black', Arial, sans-serif;
          font-size: 80px;
          color: rgba(255,255,255,0.06);
          letter-spacing: -0.04em;
          line-height: 1;
        }
        .scs-case-header-right {
          text-align: right;
        }
        .scs-case-industry {
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #DA7756;
          margin-bottom: 8px;
        }
        .scs-case-company {
          font-family: 'Archivo Black', 'Arial Black', Arial, sans-serif;
          font-size: 26px;
          color: #FFFFFF;
          letter-spacing: -0.02em;
          line-height: 1.1;
        }
        .scs-case-service {
          font-size: 12px;
          color: rgba(255,255,255,0.38);
          margin-top: 6px;
        }
        .scs-case-body {
          padding: 40px 72px 36px;
        }
        .scs-case-overview {
          font-size: 15px;
          color: #6E6E73;
          line-height: 1.75;
          margin-bottom: 28px;
          max-width: 600px;
        }
        .scs-case-rule {
          height: 1px;
          background: #EBEBEB;
          margin: 0 0 24px;
        }
        .scs-case-del-label {
          font-family: 'Archivo Black', 'Arial Black', Arial, sans-serif;
          font-size: 13px;
          color: #1D1D1F;
          letter-spacing: -0.01em;
          margin-bottom: 16px;
        }
        .scs-case-list {
          list-style: none;
          padding: 0;
          margin-bottom: 32px;
        }
        .scs-case-list li {
          font-size: 14px;
          color: #3A3A3C;
          line-height: 1.65;
          padding: 10px 0 10px 22px;
          border-bottom: 1px solid #F4F4F4;
          position: relative;
        }
        .scs-case-list li:last-child {
          border-bottom: none;
        }
        .scs-case-list li::before {
          content: "→";
          position: absolute;
          left: 0;
          color: #DA7756;
          font-weight: 700;
          font-size: 12px;
          top: 11px;
        }

        /* PROOF */
        .scs-proof-wrap {
          margin: 0 72px 40px;
          border: 1.5px solid #EBEBEB;
          border-radius: 5px;
          overflow: hidden;
        }
        .scs-proof-label {
          background: #F7F7F7;
          padding: 9px 16px;
          border-bottom: 1px solid #EBEBEB;
        }
        .scs-proof-label span {
          font-size: 10px;
          font-weight: 600;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: #AEAEB2;
        }
        .scs-proof-img {
          display: block;
          width: 100%;
          height: auto;
        }

        /* FOOTER BAR */
        .scs-case-footer {
          background: #F7F7F7;
          padding: 16px 72px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-top: 1px solid #EBEBEB;
        }
        .scs-footer-brand {
          font-family: 'Archivo Black', 'Arial Black', Arial, sans-serif;
          font-size: 11px;
          color: #AEAEB2;
          letter-spacing: -0.01em;
        }
        .scs-footer-pg {
          font-size: 11px;
          color: #AEAEB2;
        }

        /* BACK COVER */
        .scs-back {
          background: #0A0A0A;
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 72px;
          text-align: center;
        }
        .scs-back-label {
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          color: #DA7756;
          margin-bottom: 24px;
        }
        .scs-back-h2 {
          font-family: 'Archivo Black', 'Arial Black', Arial, sans-serif;
          font-size: 48px;
          line-height: 1.05;
          letter-spacing: -0.03em;
          color: #FFFFFF;
          margin-bottom: 24px;
        }
        .scs-back-sub {
          font-size: 17px;
          color: rgba(255,255,255,0.45);
          line-height: 1.65;
          max-width: 460px;
          margin: 0 auto 48px;
        }
        .scs-back-btn {
          display: inline-block;
          background: #DA7756;
          color: #FFFFFF;
          font-size: 15px;
          font-weight: 600;
          padding: 16px 40px;
          border-radius: 980px;
          text-decoration: none;
          letter-spacing: -0.01em;
          transition: background 0.2s ease, transform 0.2s ease;
        }
        .scs-back-btn:hover {
          background: #e8895e;
          transform: translateY(-2px);
        }
        .scs-back-contact {
          margin-top: 52px;
        }
        .scs-back-contact p {
          font-size: 13px;
          color: rgba(255,255,255,0.32);
          line-height: 1.9;
        }
        .scs-back-contact a {
          color: #DA7756;
          text-decoration: none;
        }

        /* RESPONSIVE */
        @media (max-width: 720px) {
          .scs-cover { padding: 40px 28px; }
          .scs-cover-h1 { font-size: 38px; }
          .scs-cover-stats { gap: 28px; }
          .scs-intro { padding: 56px 28px; }
          .scs-intro-h2 { font-size: 28px; }
          .scs-intro-grid { flex-direction: column; gap: 24px; }
          .scs-case-header { padding: 28px 28px 24px; }
          .scs-case-num { font-size: 48px; }
          .scs-case-company { font-size: 20px; }
          .scs-case-body { padding: 28px 28px 24px; }
          .scs-proof-wrap { margin: 0 28px 28px; }
          .scs-case-footer { padding: 14px 28px; }
          .scs-back { padding: 48px 28px; }
          .scs-back-h2 { font-size: 30px; }
          .scs-back-sub { font-size: 15px; }
        }
      `}</style>
    </div>
  );
}
